import { getClerkUserFacingError } from './get-clerk-user-facing-error';

interface ClerkErrorLike {
  message: string;
}

interface ResolveContext {
  flow: 'sign-in' | 'sign-up' | 'google-sign-in';
  userInfo?: Record<string, unknown>;
  fallback: string;
}

/**
 * Resolves a Clerk error object to the single string the UI should
 * surface. Order of preference: a verification-strategy-aware
 * remapping from `getClerkUserFacingError`, then Clerk's raw
 * message, then the caller's fallback. `error` may be `null` or
 * missing a message — in either case the fallback is used.
 */
export function resolveClerkErrorMessage(
  error: ClerkErrorLike | null | undefined,
  context: ResolveContext
): string {
  const clerkMessage = error?.message;
  if (clerkMessage) {
    const userFacing = getClerkUserFacingError(clerkMessage, {
      flow: context.flow,
      userInfo: context.userInfo,
    });
    if (userFacing) return userFacing;
    return clerkMessage;
  }
  return context.fallback;
}
